import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { Table } from 'reactstrap';
import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
import './courtList.css';
import styles from './style'
var Spinner = require('react-spinkit');
import Dialog from 'material-ui/Dialog';

const headings = ['Name','Size','Field Type','Surface Type','Price','Action']

class CourtList extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			venue_id: props.match.params.id,
			court_data: [],
			loading: true,
			selectedGametype: null,
		}
	}

	componentDidMount() {
		this.getCourtsInAVenue()
	}

	getCourtsInAVenue() {
		this.setState({loading: true})
		const url = `${getLocationOrigin()}/court_booking/get_courts_in_a_venue/?venue_id=${this.state.venue_id}`
		const options = {...defaultOptions};

		return fetch(url,options)
		.then(checkStatus)
		.then(parseJSON)
		.then(data=>{
			if(data.success) {
				this.setState({court_data: data.result,selectedGametype:data.result.games[0].pk})
			}
			else{
        		alert(data.message)
       		}
		})
		.catch(error=> error)
		.finally(()=> {
			this.setState({loading: false})
		})
	}

	render() {
		console.log('--state--',this.state)
		let gameTypeList = []
		if(this.state.selectedGametype) {
			gameTypeList =  this.state.court_data.data.filter(item => item.game.pk == this.state.selectedGametype)
		}
		else {
			gameTypeList = this.state.court_data.data
		}


		return(
			<div className='courtlist'>
				<div className='header-top'>
					<button className='back-btn' onClick={() => history.back()}>
						<i className="fa fa-arrow-left" aria-hidden="true"></i>
					</button>
					{/*<h4 className='header-title'>Courts</h4>*/}
				</div>
				{this.state.loading ? 
					<div className="loading-overlay" style={{display:'flex',background:'none',top:0}}>
            <Spinner name="line-scale-pulse-out" color="#115691" fadeIn='quarter'/>
          </div>
        : (
        		<div>
							<div className='add-court-container'>
								{this.state.court_data && this.state.court_data.games && 
								<div style={styles.labelSelect}>
									<label for='text' style={{margin:'0'}}>Sport : </label>
										<select className='form-control' style={{width:'max-content'}} value={this.state.selectedGametype} onChange={(e)=>this.setState({selectedGametype:e.target.value})}>
											<option disabled>Select a sport</option>
											{this.state.court_data.games.map((item)=>(
												<option key={item.pk} value={item.pk}>{item.name}</option>
											))}
										</select>
									</div>
								}
								<Link to={`../addCourt/${this.state.venue_id}`} style={{color:'black'}}>
									<button className='btn btn-primary' style={styles.addCourtBtn}><i className="fa fa-plus-circle " aria-hidden="true" style={{paddingRight:'5px'}}></i>Add Court</button>
								</Link>	
							</div>
							{this.state.court_data && this.state.court_data.data && 
								<Table responsive style={styles.courtTable}>
									<thead>
										<tr>
											{headings.map((item,index)=>(
												<th key={index} style={styles.actionTabRow}>{item}</th>
											))}
										</tr>
									</thead>
									<tbody>
										{gameTypeList && gameTypeList.map((item,index)=> (
												<tr>
													<td style={styles.tableData}><span>{item.name}</span></td>
													<td style={styles.tableData}><span>{item.size}</span></td>
													<td style={styles.tableData}><span>{item.field_type}</span></td>
													<td style={styles.tableData}><span>{item.surface_type}</span></td>
													<td style={styles.tableData}><span>{item.price}</span></td>
													<td style={styles.tableData}>
														<Link to={`../editCourt/${item.id}`} style={{color:'#444444'}}>
															<i className="fa fa-pencil-square-o fa-lg" aria-hidden="true" style={{cursor:'pointer'}}></i>
														</Link>
													</td>
												</tr>
										))}
									</tbody>
								</Table>
							}
						</div>
          )
        }		
			</div>
		)
	}
}

export default CourtList;


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/addCourt/CourtList.js